import React from "react";
import { reportClientError } from "@/lib/errorReporter";

// App-wide React error boundary. Catches render-time crashes, reports them to the
// Founder System Health view, and shows a calm HUD fallback with a reload action.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    reportClientError({
      name: error?.name || "RenderError",
      message: error?.message || "React render error",
      stack: `${error?.stack || ""}\n${info?.componentStack || ""}`,
      context: "react-error-boundary",
    });
  }

  handleReload = () => {
    if (typeof window !== "undefined") window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        data-testid="error-boundary-fallback"
        className="min-h-screen flex items-center justify-center bg-[#E5EBDD] px-6"
      >
        <div className="max-w-md w-full text-center bg-[#FAF6EC] rounded-3xl p-10 shadow-xl border border-black/5">
          <div className="w-14 h-14 mx-auto rounded-2xl bg-[#1A4331]/10 flex items-center justify-center mb-5">
            <span className="text-2xl">🌱</span>
          </div>
          <h1 className="text-2xl font-bold text-[#1A4331] mb-2">
            Something needs a prune
          </h1>
          <p className="text-[#5C665C] mb-7 leading-relaxed">
            A small hiccup stopped this screen from loading. Your garden data is
            safe — reload to get growing again.
          </p>
          <button
            data-testid="error-boundary-reload"
            onClick={this.handleReload}
            className="w-full py-3 rounded-full bg-[#1A4331] text-[#FAF6EC] font-semibold hover:bg-[#0F2D1F] transition-colors"
          >
            Reload Homegrown
          </button>
        </div>
      </div>
    );
  }
}
